import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// ── en locale ─────────────────────────────────────────────────────────────────
import enNav from "./locales/en/nav.json";
import enCommon from "./locales/en/common.json";
import enEntities from "./locales/en/entities.json";
import enFields from "./locales/en/fields.json";
import enRenewals from "./locales/en/renewals.json";
import enBell from "./locales/en/bell.json";
import enAudit from "./locales/en/audit.json";
import enAdmin from "./locales/en/admin.json";
import enSettings from "./locales/en/settings.json";
import enChat from "./locales/en/chat.json";
import enAuth from "./locales/en/auth.json";
import enErrors from "./locales/en/errors.json";
import enStatus from "./locales/en/status.json";
import enCycles from "./locales/en/cycles.json";
import enObligations from "./locales/en/obligations.json";
import enTypedFields from "./locales/en/typed_fields.json";
import enRegulatory from "./locales/en/regulatory.json";
import enDocuments from "./locales/en/documents.json";
import enOwnership from "./locales/en/ownership.json";
import enDirectors from "./locales/en/directors.json";
import enTooltip from "./locales/en/tooltip.json";
import enCountry from "./locales/en/country.json";

// ── fr locale ─────────────────────────────────────────────────────────────────
import frNav from "./locales/fr/nav.json";
import frCommon from "./locales/fr/common.json";
import frEntities from "./locales/fr/entities.json";
import frFields from "./locales/fr/fields.json";
import frRenewals from "./locales/fr/renewals.json";
import frBell from "./locales/fr/bell.json";
import frAudit from "./locales/fr/audit.json";
import frAdmin from "./locales/fr/admin.json";
import frSettings from "./locales/fr/settings.json";
import frChat from "./locales/fr/chat.json";
import frAuth from "./locales/fr/auth.json";
import frErrors from "./locales/fr/errors.json";
import frStatus from "./locales/fr/status.json";
import frCycles from "./locales/fr/cycles.json";
import frObligations from "./locales/fr/obligations.json";
import frTypedFields from "./locales/fr/typed_fields.json";
import frRegulatory from "./locales/fr/regulatory.json";
import frDocuments from "./locales/fr/documents.json";
import frOwnership from "./locales/fr/ownership.json";
import frDirectors from "./locales/fr/directors.json";
import frTooltip from "./locales/fr/tooltip.json";
import frCountry from "./locales/fr/country.json";

// Bootstrap: read stored language preference synchronously so the initial
// render uses the correct locale without a flicker.
function getBootstrapLng(): string {
  try {
    const raw = window.localStorage.getItem("hightekers.user.preferences");
    if (!raw) return "en";
    const parsed = JSON.parse(raw) as { language?: string };
    return parsed.language === "fr" ? "fr" : "en";
  } catch {
    return "en";
  }
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        nav: enNav,
        common: enCommon,
        entities: enEntities,
        fields: enFields,
        renewals: enRenewals,
        bell: enBell,
        audit: enAudit,
        admin: enAdmin,
        settings: enSettings,
        chat: enChat,
        auth: enAuth,
        errors: enErrors,
        status: enStatus,
        cycles: enCycles,
        obligations: enObligations,
        typed_fields: enTypedFields,
        regulatory: enRegulatory,
        documents: enDocuments,
        ownership: enOwnership,
        directors: enDirectors,
        tooltip: enTooltip,
        country: enCountry,
      },
      fr: {
        nav: frNav,
        common: frCommon,
        entities: frEntities,
        fields: frFields,
        renewals: frRenewals,
        bell: frBell,
        audit: frAudit,
        admin: frAdmin,
        settings: frSettings,
        chat: frChat,
        auth: frAuth,
        errors: frErrors,
        status: frStatus,
        cycles: frCycles,
        obligations: frObligations,
        typed_fields: frTypedFields,
        regulatory: frRegulatory,
        documents: frDocuments,
        ownership: frOwnership,
        directors: frDirectors,
        tooltip: frTooltip,
        country: frCountry,
      },
    },
    // Read bootstrap language from localStorage directly; do not use the
    // LanguageDetector caching (it doesn't understand our nested JSON shape).
    detection: {
      order: [],
      caches: [],
    },
    lng: getBootstrapLng(),
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: { escapeValue: false }, // React escapes by default.
    react: { useSuspense: false },          // Suspense not in use; avoids flicker.
  });

export default i18n;
